<template>
  <div class="beast-menu">
    <div class="menu-wrap">
      <div class="menu-member">
        <div class="member-logo">
          <img v-if="member" :src="member && member.level.avatarUrl" />
          <img v-else src="../assets/icon-nologin.png" />
        </div>
        <div class="member-infos">
          <div class="member-name">{{ member && member.profile.nickName }}</div>
          <div class="member-account" v-if="member"><a href="/my">我的账号<i></i></a></div>
          <div class="member-account no-login" v-else><a href="/my">登录/快速注册<i></i></a></div>
        </div>
        <span class="close-member" @click="closeMenu"></span>
      </div>
      <div class="menu-list">
        <div class="menu-group">
          <div class="menu-item"
            >
            <h2 @click="jump(null, {type: 'index', value: ''}, $event)">首页</h2>
          </div>
          <div class="menu-item"
            v-for="item in menu">
            <h2 @click="jump(item.data.subCategory, item.data.link, $event)">{{ item.data.title }}<i v-if="item.data.subCategory.length"></i></h2>
            <ul class="menu-item-child"
              v-if="item.data.subCategory.length"
              v-show="item.expand"
              :data-show="item.expand && 'block'">
              <li class="menu-child-item"
                v-for="child in item.data.subCategory"
                @click="jump(null, child.link, $event)">
                {{ child.title }}
              </li>
            </ul>
          </div>
          <div class="menu-item"
            >
            <h2 @click="jump(null, {type: 'custom', value: ''}, $event)">高级定制</h2>
          </div>
          <div class="menu-item"
            >
            <h2 @click="jump(null, {type: 'discount', value: ''}, $event)">折扣优惠</h2>
          </div>
          <div class="menu-item"
            >
            <h2 @click="jump(null, {type: 'retail', value: ''}, $event)">实体店</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string'

import {
  getLink
} from '../util'

import {
  getMember
} from '../apis'


export default {
  props: ['data'],

  data () {
    return {
      menu: this.data,
      member: null,
      isShow: false
    }
  },

  created () {
    if (!this.member) {
       getMember()
      .then(data => {
        this.member = data
      })
      .catch(err => {})
    }
  },

  methods: {
    jump (expand, link, e) {
      if(expand && expand.length) {
        this.showChild(e)
      }
      else { 
        link = this.formatLink(link)

        let url = getLink(link)
        window.location.href = url
      }
    },

    closeMenu () {
      this.$emit('close')
    },

    showChild (e) {
      const tar = e.currentTarget
      const item = tar.nextElementSibling
      let isShow = item.dataset.show

      if (isShow !== 'block') {
        isShow = 'block'
      }
      else {
        isShow = 'none'
      }

      tar.dataset.show = isShow
      item.dataset.show = isShow
      item.style.display = isShow
    },

    formatLink (link) {
      const {
        type,
        value
      } = link

      if (type == 'none') return false

      let deeplink = 'beastapp://'

      switch (type) {
        case 'article':
          deeplink = `${deeplink}article/${value}`
          break
        case 'shop':
          deeplink = `${deeplink}shop/${value}`
          break
        case 'shop-story':
          deeplink = `${deeplink}entry?name=shop-story&shopId=${value}`
          break
        case 'list':
          deeplink = `${deeplink}search?listId=${value}`
          break
        case 'category':
          deeplink = `${deeplink}search?categoryId=${value}`
          break
        case 'product':
          deeplink = `${deeplink}product/${value}`
          break
        case 'oversea':
          deeplink = `${deeplink}search?overseasOnly=true`
          break
        case 'categoryOversea':
          deeplink = `${deeplink}search?overseasOnly=true&categoryId=${value}`
          break
        case 'deeplink':
          deeplink = `${value}`
          break
        case 'brand':
          deeplink = `${deeplink}search?brandId=${value}`
          break
        case 'tag':
          deeplink = `${deeplink}search?labelId=${value}`
          break
        case 'group':
          deeplink = `${deeplink}entry?name=group-purchase&productId=${value}`
          break
        case 'new':
          deeplink = `${deeplink}search?new=1`
          break
        case 'custom':
          deeplink = `${deeplink}entry?name=customization-list`
          break
        case 'discount':
          deeplink = `${deeplink}search?param=discount&title=折扣`
          break
        case 'retail':
          deeplink = `${deeplink}entry?name=retail&title=实体店`
          break
        case 'index':
          deeplink = `${deeplink}index`
          break
      }

      return deeplink
    }
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// main.vue?80fd490e